import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function Gallery() {
  const images = [
    { thumb: '/images/icons/Annual Day.jpg', full: '/images/icons/1Annual Day.jpg', title: 'Annual Day' },
    { thumb: '/images/icons/Annual Scholarship Program.jpg', full: '/images/icons/2Annual Scholarship Program.jpg', title: 'Annual Scholarship' },
    { thumb: '/images/icons/Avishkaara Fest.jpg', full: '/images/icons/3Avishkaara Fest.jpg', title: 'Avishkaara Fest' },
    { thumb: '/images/icons/Cultural Events.jpg', full: '/images/icons/4Cultural Events.jpg', title: 'Cultural Events' },
    { thumb: '/images/icons/Entrepreneurship Development                Program.jpg', full: '/images/icons/5Entrepreneurship Development                Program.jpg', title: 'Entrepreneurship' },
    { thumb: '/images/icons/Fashion Show.jpg', full: '/images/icons/6Fashion Show.jpg', title: 'Fashion Show' },
    { thumb: '/images/icons/Inauguration of ISRP Rotaract            Club.jpg', full: '/images/icons/7Inauguration of ISRP Rotaract            Club.jpg', title: 'Inauguration' },
    { thumb: '/images/icons/Independence Day.jpg', full: '/images/icons/8Independence Day.jpg', title: 'Independence Day' },
    { thumb: '/images/icons/Industrial Visit.jpg', full: '/images/icons/9Industrial Visit.jpg', title: 'Industrial Visit' },
    { thumb: '/images/icons/Project Day.jpg', full: '/images/icons/10Project Day.jpg', title: 'Project Day' },
    { thumb: '/images/icons/Sports Day.jpg', full: '/images/icons/11Sports Day.jpg', title: 'Sports Day' },
    { thumb: '/images/icons/Vanamahotsava.jpg', full: '/images/icons/12Vanamahotsava.jpg', title: 'Vanamahotsava' }
  ];

  return (
    <div id="top">
      <div id="wrapper">
        <Header />
        <div id="navig_inside">
          <Navigation />
        </div>
        <div id="banner"></div>
        <div id="inside_page" className="bodyText">
          <div id="page1">
            <span className="bodyText">
              <p className="welcome_heading"><strong>Photogallery</strong></p>
              <div className="clear"></div>
            </span>
            <div id="facil">
              <p style={{ textAlign: 'center' }}>&nbsp;</p>
              <p style={{ textAlign: 'center', color: '#990000' }} className="hWords">
                <table width="900" border="0" align="center" cellPadding="0" cellSpacing="0">
                  <tbody>
                    <tr>
                      <td width="200"><div style={{ textAlign: 'center' }}><a rel="lightbox[gal]" href={images[0].full} title={images[0].title}><img src={images[0].thumb} width="200" height="133" border="0" alt={images[0].title} /></a></div></td>
                      <td width="33" rowSpan="5">&nbsp;</td>
                      <td width="200"><div style={{ textAlign: 'center' }} className="hWords"><a rel="lightbox[gal]" href={images[1].full} title={images[1].title}><img src={images[1].thumb} width="200" height="133" border="0" alt={images[1].title} /></a></div></td>
                      <td width="34" rowSpan="5">&nbsp;</td>
                      <td width="200"><div style={{ textAlign: 'center' }} className="hWords"><a rel="lightbox[gal]" href={images[2].full} title={images[2].title}><img src={images[2].thumb} width="199" height="133" border="0" alt={images[2].title} /></a></div></td>
                      <td width="33" rowSpan="5">&nbsp;</td>
                      <td width="200"><div style={{ textAlign: 'center' }}><a rel="lightbox[gal]" href={images[3].full} title={images[3].title}><img src={images[3].thumb} width="200" height="133" border="0" alt={images[3].title} /></a></div></td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: 'center' }} className="hWords">Annual Day<br /></td>
                      <td width="200" style={{ textAlign: 'center' }}><span className="hWords">Annual Scholarship Program<br />
                      </span></td>
                      <td width="200" style={{ textAlign: 'center' }}><span className="hWords">Avishkaara Fest<br />
                      </span></td>
                      <td width="241" style={{ textAlign: 'center' }}><span className="hWords">Cultural Events<br />
                      </span></td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td width="200">&nbsp;</td>
                      <td width="200">&nbsp;</td>
                      <td width="241">&nbsp;</td>
                    </tr>
                    <tr>
                      <td><div style={{ textAlign: 'center' }}><a rel="lightbox[gal]" href={images[4].full} title={images[4].title}><img src={images[4].thumb} width="198" height="133" border="0" alt={images[4].title} /></a></div></td>
                      <td width="200"><div style={{ textAlign: 'center' }}><a rel="lightbox[gal]" href={images[5].full} title={images[5].title}><img src={images[5].thumb} width="200" height="133" border="0" alt={images[5].title} /></a></div></td>
                      <td width="200"><div style={{ textAlign: 'center' }}><a rel="lightbox[gal]" href={images[6].full} title={images[6].title}><img src={images[6].thumb} width="177" height="133" border="0" alt={images[6].title} /></a></div></td>
                      <td width="241"><div style={{ textAlign: 'center' }}><a rel="lightbox[gal]" href={images[7].full} title={images[7].title}><img src={images[7].thumb} width="200" height="100" border="0" alt={images[7].title} /></a></div></td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: 'center' }}><span className="hWords">Entrepreneurship Development Program</span></td>
                      <td width="200" style={{ textAlign: 'center' }}><span className="hWords">Fashion Show</span></td>
                      <td width="200" style={{ textAlign: 'center' }}><span className="hWords">Inauguration of ISRP Rotaract Club</span></td>
                      <td width="241" style={{ textAlign: 'center' }} className="hWords">Independence Day</td>
                    </tr>
                  </tbody>
                </table>
                <strong><br />
                </strong> </p>
              <table width="900" border="0" align="center" cellPadding="0" cellSpacing="0">
                <tbody>
                  <tr>
                    <td width="200"><div style={{ textAlign: 'center' }}><a rel="lightbox[gal]" href={images[8].full} title={images[8].title}><img src={images[8].thumb} width="177" height="133" border="0" alt={images[8].title} /></a></div></td>
                    <td width="33" rowSpan="5">&nbsp;</td>
                    <td width="200"><div style={{ textAlign: 'center' }} className="hWords"><a rel="lightbox[gal]" href={images[9].full} title={images[9].title}><img src={images[9].thumb} width="177" height="133" border="0" alt={images[9].title} /></a></div></td>
                    <td width="34" rowSpan="5">&nbsp;</td>
                    <td width="200"><div style={{ textAlign: 'center' }} className="hWords"><a rel="lightbox[gal]" href={images[10].full} title={images[10].title}><img src={images[10].thumb} width="177" height="133" border="0" alt={images[10].title} /></a></div></td>
                    <td width="33" rowSpan="5">&nbsp;</td>
                    <td width="200"><div style={{ textAlign: 'center' }}><a rel="lightbox[gal]" href={images[11].full} title={images[11].title}><img src={images[11].thumb} width="200" height="133" border="0" alt={images[11].title} /></a></div></td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: 'center' }} className="hWords"><p>Industrial Visit</p>
                      <p>&nbsp;</p></td>
                    <td width="200" style={{ textAlign: 'center' }}><span className="hWords">Project Day</span></td>
                    <td width="200" style={{ textAlign: 'center' }}><span className="hWords">Sports Day</span></td>
                    <td width="241" style={{ textAlign: 'center' }}><span className="hWords">Vanamahotsava</span></td>
                  </tr>
                </tbody>
              </table>
              <p>&nbsp;</p>
              <strong><br />
              </strong>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Gallery;
